import React, { Component, ReactNode } from "react";
import GoogleMapReact from "google-map-react";
import RoomIcon from "@mui/icons-material/Room";

const AnyReactComponent = ({ text, lat, lng }) => (
	<div>
		<RoomIcon className="text-red-500" />
	</div>
);

export function VetMapUnavailable() {
	return <p role="status" className="p-[28px]">Map unavailable. You can still use the contact details on this page.</p>;
}

class MapErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
	state = { failed: false };
	static getDerivedStateFromError() { return { failed: true }; }
	render() { return this.state.failed ? <VetMapUnavailable /> : this.props.children; }
}

function VetMap({ lat, lng, vetName = "" }) {
	const key = process.env.VITE_APP_GOOGLE;
	const defaultProps = {
		center: {
			lat: lat,
			lng: lng,
		},
		zoom: 9,
	};

	return (
		<div className="h-full w-full">
			<MapErrorBoundary key={`${lat}:${lng}`}>
			<GoogleMapReact
				bootstrapURLKeys={{
					key: key,
				}}
				defaultCenter={defaultProps.center}
				defaultZoom={defaultProps.zoom}
			>
				<AnyReactComponent lat={lat} lng={lng} text={vetName} />
			</GoogleMapReact>
			</MapErrorBoundary>
		</div>
	);
}

export default VetMap;
